import { apiClient } from "@/api";
import { ApiResponse } from "@/types";
import { AxiosRequestConfig } from "axios";

export interface LoginReq {
  email: string;
  password: string;
}

export interface LoginRes {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

export interface AdminMe {
  id: string;
  name: string;
  email: string;
  role: string;
}

const adminLogin = async (req: LoginReq, config?: AxiosRequestConfig) => {
  return apiClient.post<ApiResponse<LoginRes>>("/admins/auth/login", req, config);
};

const adminRefreshToken = async (refreshToken: string, config?: AxiosRequestConfig) => {
  return apiClient.post<ApiResponse<LoginRes>>("/admins/auth/refresh", {
    refresh_token: refreshToken,
  }, config);
};

const adminLogout = async (config?: AxiosRequestConfig) => {
  return apiClient.post<void>("/admins/auth/logout", undefined, config);
};

const adminGetMe = async (config?: AxiosRequestConfig) => {
  return apiClient.get<ApiResponse<AdminMe>>("/admins/auth/me", config);
};

const adminSsoLogin = async (accessToken: string, config?: AxiosRequestConfig) => {
  return apiClient.post<ApiResponse<LoginRes>>("/admins/auth/sso/login", {
    access_token: accessToken,
  }, config);
};

export const AdminAuthService = () => {
  return {
    adminLogout,
    adminLogin,
    adminSsoLogin,
    adminRefreshToken,
    adminGetMe,
  };
};
